import React from 'react'
import { PREFIX_REPOSITORY, POSTFIX_REPOSITORY } from '../../constants/URLs'
import { GTMEvents } from '../../lib/GTMevents'
import { Warning } from '../../svg/warning'
import ListLink from '../listLink/listLink'

const dataLinkOne = [
  {
    title: 'Declaración Jurada del Empleador a la AFP.',
    link: PREFIX_REPOSITORY + '2020/' + encodeURIComponent('Afiliacion Pesqueros - DJ empleador.docx') + POSTFIX_REPOSITORY,
    GTMOptionSection: 'trabajadores pesqueros',
    GTMOptionSub_section: 'Afiliación de los trabajadores pesqueros',
    GTMOptionOption: 'Declaración Jurada del Empleador a la AFP.',
    GTMOptionLocation: '/trabajadores-pesqueros/',
  },
  {
    title: 'Archivo para incluir el listado de trabajadores.',
    link: PREFIX_REPOSITORY + '2020/' + encodeURIComponent('Afiliación Pesqueros - Lista de Trabajadores.xls') + POSTFIX_REPOSITORY,
    GTMOptionSection: 'trabajadores pesqueros',
    GTMOptionSub_section: 'Afiliación de los trabajadores pesqueros',
    GTMOptionOption: 'Archivo para incluir el listado de trabajadores.',
    GTMOptionLocation: '/trabajadores-pesqueros/',
  },
]

export const dataListItem = [
  {
    id: 1,
    title: 'Descarga los formularios:',
    subtitle: 'Trámite virtual',
    content: (
      <div>
        <p className={`tw-mb-4`}>
          <strong>Descarga los formatos aquí:</strong>
        </p>
        <div>
          {dataLinkOne.map((props) => (
            <ListLink
              event={()=> GTMEvents.CardFormatosAfiliarTrabajadoresPesqueros(props.GTMOptionSection, props.GTMOptionSub_section, props.GTMOptionOption, props.GTMOptionLocation )}
              title={props.title}
              link={props.link}
              key={props.title}
            />
          ))}
        </div>
      </div>
    ),
  },
  {
    id: 2,
    title: 'Declaración jurada',
    subtitle: 'Trámite virtual',
    content: (
      <div>
        <p className={`tw-mb-0`}>
          Completa e imprime la Declaración Jurada en una hoja membretada de tu
          empresa, la cual debe tener la firma y sello del Representante Legal.
        </p>
      </div>
    ),
  },
  {
    id: 3,
    title: 'Lista de trabajadores',
    subtitle: 'Trámite virtual',
    content: (
      <div>
        <p className={`tw-mb-0`}>
          Completa la lista de trabajadores que deseen afiliarse a la AFP en el
          formato Excel que has descargado. Ten en cuenta que en caso no se
          hayan llenado todos los datos solicitados no se podrá afiliar a sus
          trabajadores.
        </p>
      </div>
    ),
  },
  {
    id: 4,
    title: 'Solicitud de afiliación',
    subtitle: 'Trámite virtual',
    content: (
      <div>
        <p className={`tw-mb-4`}>
          Envía un correo electrónico a{' '}
          <a
            onClick={() => GTMEvents.LinkCorreoTrabajadoresPesqueros('trabajadores pesqueros', 'Afiliación de los trabajadores pesqueros', 'pesqueros@afpnet.com.pe', '/trabajadores-pesqueros/')}
            className="c-gray--4 b underline"
            target="_blank"
            rel="noopener noreferrer"
            href="mailto: pesqueros@afpnet.com.pe"
          >
            pesqueros@afpnet.com.pe
          </a>{' '}
          con las siguientes características:
        </p>
        <div>
          <ul className={'bulletList-0 font-family-primary tw-f-16'}>
            <li>
              Asunto: SOLICITUD DE AFILIACIÓN DE TRABAJADORES PESQUEROS AL SPP.
            </li>
            <li>
              Adjuntos.
              <ul className={'bulletList-2 font-family-primary tw-f-16'}>
                <li>Declaración Jurada firmada escaneada.</li>
                <li>
                  Documento de identidad del Representante Legal escaneado.
                </li>
                <li>
                  Archivo Excel con la lista de trabajadores en el formato
                  descargado.
                </li>
              </ul>
            </li>
            <li>
              Texto del mensaje.
              <ul className={'bulletList-2 font-family-primary tw-f-16'}>
                <li>RUC del Empleador : (RUC de la empresa)</li>
                <li>Razón Social: (Razón social de la Empresa)</li>
                <li>AFP elegida: (Prima AFP)</li>
              </ul>
            </li>
          </ul>
        </div>
        <div
          className={`brad-4 bg-orange-4 tw-p-4 tw-pb-3 font-family-primary tw-f-16`}
        >
          <div className={`flex`}>
            <div className={`tw-mr-2`}>
              <Warning fill={'#FF4F00'} />
            </div>
            <div>
              <p className={`tw-mb-2`}>
                <strong>Importante</strong>
              </p>
              <p className={`tw-mb-0`}>
                Para agilizar el procedimiento le recomendamos que el correo
                electrónico sea enviado desde su dirección registrada en AFPnet.
              </p>
            </div>
          </div>
        </div>
      </div>
    ),
  },
  {
    id: 5,
    title: 'Confirmación',
    subtitle: 'Trámite virtual',
    content: (
      <div>
        <p className={`tw-mb-0`}>
          Recibirás un correo electrónico de respuesta confirmando la recepción
          de la solicitud dentro de los 3 días útiles siguientes. Este correo se
          dirigirá a la dirección desde la cual se remitió la solicitud.
        </p>
      </div>
    ),
  },
  {
    id: 6,
    title: 'Resultados',
    subtitle: 'Trámite virtual',
    content: (
      <div>
        <p className={`tw-mb-0`}>
          Recibirás un correo electrónico con el resultado de las afiliaciones
          solicitadas. Este correo se dirigirá a la dirección del Representante
          Legal de la empresa, registrada en AFPnet.
        </p>
      </div>
    ),
  },
]
